import AxiosInstance from './config/Http'
import Config from './config/Constants'


export const getNotificationsByUser = async (isRead:string='',isNotif:string='') => AxiosInstance.get(`${Config.core.notificationsByUser}?page=0&size=999&sort=creationDate,desc${isRead && '&isRead.equals=0'}${isNotif && '&isNotif.equals=1'}`)


export const deleteNotifications = async (id:string) => 
AxiosInstance.delete(`${Config.core.notifications}/${id}`);

export const patchNotifications = async (id: string, body: any) => 
AxiosInstance.patch<any>(`${Config.core.notifications}/${id}`, body);

export const patchNotificationsByUser = async (id: string, body: any) => 
AxiosInstance.patch<any>(`${Config.core.notificationsByUser}/${id}`, body);


 